// extracted by mini-css-extract-plugin
module.exports = {"container":"_45bf7382","fraction":"_17914eaf","readReviews":"_eeabf4de"};